"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _a;
var LANG = 'default';
var LOCALES = (_a = {},
    _a[LANG] = {},
    _a);
var observers = [];
function addLangObserver(fn) {
    observers.push(fn);
    return function () {
        observers.splice(observers.indexOf(fn), 1);
    };
}
exports.addLangObserver = addLangObserver;
function setLang(name) {
    if (LANG !== name) {
        var old_1 = LANG;
        LANG = name;
        observers.forEach(function (fn) {
            fn(LANG, old_1);
        });
    }
}
exports.setLang = setLang;
function getLang() {
    return LANG;
}
exports.getLang = getLang;
function getLocale(lang) {
    return LOCALES[lang];
}
exports.getLocale = getLocale;
function setLocale(lang, locale) {
    LOCALES[lang] = locale;
}
exports.setLocale = setLocale;
function setDefaultLocale(locale) {
    setLocale('default', locale);
}
exports.setDefaultLocale = setDefaultLocale;
function getTranslate(phrase, lang, ctx) {
    if (lang === void 0) { lang = LANG; }
    if (ctx === void 0) { ctx = 'default'; }
    if (LOCALES.hasOwnProperty(lang)) {
        if (LOCALES[lang].hasOwnProperty(ctx)
            && LOCALES[lang][ctx].hasOwnProperty(phrase)) {
            return LOCALES[lang][ctx][phrase];
        }
        else if (ctx !== 'default'
            && LOCALES[lang].hasOwnProperty('default')
            && LOCALES[lang].default.hasOwnProperty(phrase)) {
            return LOCALES[lang].default[phrase];
        }
    }
    // todo: warning not translated phrase
    return phrase;
}
exports.getTranslate = getTranslate;
